"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRecommendationBusinessSolutions = void 0;
var _recommendationSelectors = require("../../store/recommendation/recommendationSelectors");
var _useRecommendationStatus = require("./useRecommendationStatus");
var _constants = require("../../utils/constants");
var _recommendationActions = require("../../store/recommendation/recommendationActions");
var _useAppDispatch = require("../useAppDispatch");
var _useAppSelector = require("../useAppSelector");
const getSelectedBusinessSolution = () => {
  const selectedBusinessSolution = (0, _useAppSelector.useAppSelector)(_recommendationSelectors.selectSelectedBusinessSolution);
  const selectedVariant = selectedBusinessSolution.selectedVariant;
  return {
    ...selectedBusinessSolution,
    ...selectedVariant
  };
};
const getBusinessSolution = tier => {
  const businessSolution = (0, _useAppSelector.useAppSelector)(instanceId => state => (0, _recommendationSelectors.selectBusinessSolution)(state, tier, instanceId));
  if (!businessSolution) {
    return null;
  }
  return {
    ...businessSolution
  };
};
const useRecommendationBusinessSolutions = () => {
  const dispatch = (0, _useAppDispatch.useAppDispatch)();
  const {
    areBusinessSolutionsPresent
  } = (0, _useRecommendationStatus.useRecommendationStatus)();
  if (!areBusinessSolutionsPresent) {
    return {};
  }
  const recommendedBusinessSolution = getBusinessSolution(_constants.RECOMMENDATION_TIER.RECOMMENDED);
  const premiumBusinessSolution = getBusinessSolution(_constants.RECOMMENDATION_TIER.PREMIUM);
  const budgetBusinessSolution = getBusinessSolution(_constants.RECOMMENDATION_TIER.BUDGET);
  const alternativeBusinessSolution = getBusinessSolution(_constants.RECOMMENDATION_TIER.ALTERNATIVE);
  const alternativePremiumBusinessSolution = !premiumBusinessSolution && alternativeBusinessSolution;
  const alternativeBudgetBusinessSolution = !alternativePremiumBusinessSolution && !budgetBusinessSolution && alternativeBusinessSolution;
  const selectedBusinessSolution = getSelectedBusinessSolution();
  const onBusinessSolutionSelect = productId => {
    dispatch((0, _recommendationActions.updateSelectedBusinessSolution)(productId));
  };
  // sec.logCustomEvent(
  //   'recommendation',
  //   `Recommended BusinessSolution: ${selectedBusinessSolution?.productName},
  //     Premium BusinessSolution: ${premiumBusinessSolution?.productName},
  //     Budget BusinessSolution: ${budgetBusinessSolution?.productName},
  //     Alt Premium BusinessSolution: ${alternativePremiumBusinessSolution?.productName},
  //     Alt Budget BusinessSolution: ${alternativeBudgetBusinessSolution?.productName},
  //     `,
  //   'recommendationPage',
  //   'recommendation BusinessSolutions',
  // );
  return {
    recommendedBusinessSolution,
    premiumBusinessSolution,
    budgetBusinessSolution,
    alternativePremiumBusinessSolution,
    alternativeBudgetBusinessSolution,
    selectedBusinessSolution,
    onBusinessSolutionSelect
  };
};
exports.useRecommendationBusinessSolutions = useRecommendationBusinessSolutions;